module.exports = __webpack_public_path__ + "img/TSGBrauchwasser.f87c9129.png";